import React, { useState } from 'react';
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import logo from '../../images/logo-image.jpeg';
import { forgotPassword } from '../../services/AuthService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await forgotPassword({ email });
      await Swal.fire({
        icon: 'success',
        title: 'Check your email',
        text: 'If the account exists, a reset link was sent.',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
    } catch (error) {
      await Swal.fire({
        icon: 'error',
        title: 'Request failed',
        text: 'Please try again.',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="vh-100" style={{ backgroundColor: '#508bfc' }}>
      <Row className="d-flex justify-content-center align-items-center h-100">
        <Col md={4} lg={4} xl={4}>
          <Card className="shadow-2-strong" style={{ borderRadius: '1rem' }}>
            <Card.Body className="p-3">
              <div className="text-center">
                <Image src={logo} alt="Logo" className="mb-2" width={'40%'} />
                <h4 className="mb-3">Forgot Password</h4>
              </div>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="form-outline mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control-lg"
                    required
                  />
                </Form.Group>
                <div className="d-grid gap-2">
                  <Button type="submit" className="btn btn-primary btn-lg" disabled={submitting}>
                    Send Reset Link
                  </Button>
                </div>
                <div className="text-center mt-3">
                  <Link to="/external-login">Back to login</Link>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </section>
  );
};

export default ForgotPassword;
